export default __webpack_public_path__ + "static/1885-a7a9b092ea4925e29d9740d87c0c72e4.gif";